import axios from "./axios_config";
import getCookie from "@/utils/get_cookie"
import {auth} from "../store";

const interceptorsSetup = ():void => {
  axios.interceptors.request.use(
    (config) => {
      let csrf = getCookie('csrftoken')
      if (csrf){
        config.headers.common['X-CSRFToken'] = csrf
      }
      return config
    }
  )
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      // Si existe un error de autenticación forza al usuario a loggear otra vez
      if (error.response.status === 403) {
        auth.dispatch("authLogout");
      }
      // No special treatement of any other error
      return Promise.reject(error);
    }
  );
};

export default interceptorsSetup
